(function() {
  const top_bar_height = 33;

  $('.site-header').hover(function () {
    $(this).addClass('active');
  },
  function() {
    $(this).removeClass('active');
  });

  $(window).on('scroll', function() {
    if ($(window).scrollTop() > top_bar_height) {
      $('.sticky').addClass('stuck')
    } else {
      $('.sticky').removeClass('stuck')
    }
  });

  $(document).ready(function() {
    if ($(window).scrollTop() > top_bar_height) {
      $('.sticky').addClass('stuck')
    } else {
      $('.sticky').removeClass('stuck')
    }
  });
})();
